module.exports = __webpack_public_path__ + "img/marker-icon-2x-violet.edb6cda1.png";